import request from '@/utils/request'

// 保存高亮
export function saveHighlightApi(data) {
  return request({
    url: '/reader/note/add',
    method: 'post',
    data
  })
}

// 删除高亮
export function delHighlightApi(data, id) {
  return request({
    url: `/reader/note/delete/${id}`,
    method: 'post',
    data
  })
}

// 获取高亮
export function getHighlightApi(data) {
  return request({
    url: '/reader/note/detail',
    method: 'post',
    data
  })
}

// 获取图书的笔记
export function getNotes(query) {
  return request({
    url: '/reader/operation/notes',
    method: 'get',
    params: query
  })
}

// 百度翻译
export function getTrans(query) {
  return request({
    url: '/reader/trans',
    method: 'get',
    params: query
  })
}

// 获取题目分组
export function questionTreeApi(params) {
  return request({
    url: '/myQuestionGroup/getTree',
    method: 'get',
    params
  })
}

// 保存题目分组
export function saveQuestionGroupApi(data) {
  return request({
    url: '/myQuestionGroup/save',
    method: 'post',
    data
  })
}

// 修改题目分组
export function updateQuestionGroupApi(data) {
  return request({
    url: '/myQuestionGroup/modify',
    method: 'post',
    data
  })
}

// 删除题目分组
export function deleteQuestionGroupApi(data, id) {
  return request({
    url: `/myQuestionGroup/delete/${id}`,
    method: 'post',
    data
  })
}

// 移动题目分组
export function moveQuestionGroupApi(data) {
  return request({
    url: `/myQuestionGroup/move`,
    method: 'post',
    data
  })
}

// 获取题目列表
export function questionListApi(params) {
  return request({
    url: '/myQuestion/getList',
    method: 'get',
    params
  })
}

// 添加题目
export function addQuestionApi(data) {
  return request({
    url: `/myQuestion/save`,
    method: 'post',
    data
  })
}

// 修改题目
export function updateQuestionApi(data) {
  return request({
    url: `/myQuestion/modify`,
    method: 'post',
    data
  })
}

// 删除题目
export function deleteQuestionApi(data, id) {
  return request({
    url: `/myQuestion/delete/${id}`,
    method: 'post',
    data
  })
}

// 题目详情
export function questionDetailApi(params, id) {
  return request({
    url: `/myQuestion/detail/${id}`,
    method: 'get',
    params
  })
}

// 章节目录列表
export function chapterTreeApi(params) {
  return request({
    url: `/homework/sectionTree`,
    method: 'get',
    params
  })
}

// 保存测验（教师）
export function saveQuizForTeacherApi(data) {
  return request({
    url: `/homework/teacher/save`,
    method: 'post',
    data
  })
}

// 修改测验
export function updateQuizApi(data) {
  return request({
    url: `/homework/teacher/update`,
    method: 'post',
    data
  })
}

// 测验列表按章节排序（教师）
export function quizListByChapterForTeacherApi(params) {
  return request({
    url: `/homework/teacher/listByChapter`,
    method: 'get',
    params
  })
}

// 测验列表按时间排序（教师）
export function quizListByTimeForTeacherApi(params) {
  return request({
    url: `/homework/teacher/listByTime`,
    method: 'get',
    params
  })
}

// 测验详情（教师）
export function quizDetailForTeacherApi(params) {
  return request({
    url: `/homework/teacher/info`,
    method: 'get',
    params
  })
}

// 删除测验
export function deleteQuizApi(data, id) {
  return request({
    url: `/homework/teacher/delete/${id}`,
    method: 'post',
    data
  })
}

// 发布测验
export function releaseQuizApi(data) {
  return request({
    url: `/homework/teacher/release`,
    method: 'post',
    data
  })
}

// 保存测验（学生）
export function saveQuizForStudentApi(data) {
  return request({
    url: `/homework/student/save`,
    method: 'post',
    data
  })
}

// 测验列表按章节排序（学生）
export function quizListByChapterForStudentApi(params) {
  return request({
    url: `/homework/student/listByChapter`,
    method: 'get',
    params
  })
}

// 测验列表按时间排序（学生）
export function quizListByTimeForStudentApi(params) {
  return request({
    url: `/homework/student/list`,
    method: 'get',
    params
  })
}

// 测验详情（学生）
export function quizDetailForStudentApi(params) {
  return request({
    url: `/homework/student/info`,
    method: 'get',
    params
  })
}

// 提交测验
export function submitQuizApi(data) {
  return request({
    url: `/homework/student/submit`,
    method: 'post',
    data
  })
}

// 测验即将过期提醒
export function quizExpireNoticeApi(data) {
  return request({
    url: `/homework/student/expireNotice`,
    method: 'post',
    data
  })
}

// 班级列表
export function classListApi(params) {
  return request({
    url: `/homework/teacher/getClassList`,
    method: 'get',
    params
  })
}

// 资源总览-分类
export function resourceCategoryApi(params) {
  return request({
    url: `/reader/section/resource/category`,
    method: 'get',
    params
  })
}

// 资源总览-列表
export function resourceCatalogApi(params) {
  return request({
    url: `/reader/section/resource/catalog`,
    method: 'get',
    params
  })
}

// 查看学生测验详情（教师）
export function quizDetailForReviewApi(params, id) {
  return request({
    url: `/homework/teacher/reviewHomework/${id}`,
    method: 'get',
    params
  })
}

// 获取教材-用户-班级信息
export function getBookClassApi(params) {
  return request({
    url: `/api/class/getBookClass`,
    method: 'get',
    params
  })
}

// 获取教材-班级-用户角色信息
export function getClassRole(params) {
  return request({
    url: `/api/class/getClassRole`,
    method: 'get',
    params
  })
}

export function getBookClassByRoleApi(params) {
  return request({
    url: `/api/class/getBookClassByRole`,
    method: 'get',
    params
  })
}

// 获取页面上的资源
export function chapterResourceApi(params) {
  return request({
    url: `/reader/section/resource/chapter`,
    method: 'get',
    params
  })
}

// 作业、测验未完成提醒（学生）
export function incompleteNoticeApi(params) {
  return request({
    url: `/homework/student/notice`,
    method: 'get',
    params
  })
}

// 根据编辑器的练习id获取可用练习id
export function getHomeworkIdApi(params) {
  return request({
    url: '/homework/homeworConfigId',
    method: 'get',
    params
  })
}

// 获取详情页的bookid
export function getBookIdApi(params) {
  return request({
    url: '/api/book/getBookId',
    method: 'get',
    params
  })
}

export function extendLeave(data) {
  return request({
    url: '/book/extend/leave',
    method: 'post',
    data
  })
}

export function getPosition(bookId) {
  return request({
    url: '/book/extend/getPosition',
    method: 'get',
    params: {
      bookId
    }
  })
}

// 按章编辑-教材信息-本书是否是新按章编辑
export function getBookInfoExtraApi(query) {
  return request({
    url: '/api/book/info/extra',
    method: 'get',
    params: query
  })
}

// 获取章节所有uuid
export function getParagraphUUIDApi(query) {
  return request({
    url: '/reader/chapter/getParagraphUUID',
    method: 'get',
    params: query
  })
}

// 获取章节首尾
export function getFirstAndLastUUIDApi(query) {
  return request({
    url: '/reader/chapter/getFirstAndLastUUID',
    method: 'get',
    params: query
  })
}

// 获取本书已读章节H
export function getHasReadApi(query) {
  return request({
    url: '/reader/section/hasRead',
    method: 'get',
    params: query
  })
}

//阅读设置
export function personalSettingApi(data) {
  return request({
    url: `/reader/section/personalSetting/set`,
    method: 'post',
    data
  })
}

// 推荐图书/论文
export function readerSectionChapterRecommendApi(params) {
  return request({
    url: `/reader/section/chapter-recommend`,
    method: 'get',
    params
  })
}

// 判断有没有练习权限
export function checkPermissionApi(params) {
  return request({
    url: `/homework/checkPermission`,
    method: 'get',
    params
  })
}